import React, { useState } from 'react';
import { connect } from 'react-redux';
import { deleteMapElement } from '../../../../../actions/reduxActions/mapElements';
import { editNote } from '../../../../../actions/reduxActions/canvasNotes';

import classnames from 'classnames';
import moment from 'moment';


/**
 * 
 * @param {String} subject The note subject heading
 * @param {String} content The text content to be displayed
 * @param {String} email The email of the note creator
 * @param {String} lastUpdated The timestamp of when the note was last modified
 * @param {Function} remove Deletes the note
 * @param {String} id The note ID
 * @param {String} flowId 
 * @param {String} editingToken 
 * @param {Object} currentUser 
 * @param {Function} edit Toggles whether the note is read only
 * 
 * @description Displays the read only note content 
 */
const NoteDisplay = ({ subject, content, email, lastUpdated, remove, id, flowId, editingToken, currentUser, edit }) => {
    const [dropDownIsOpen, toggleDropdown] = useState(false);
    const onDelete = () => {
        const { authenticationToken, tenantId } = currentUser;
        remove(id, flowId, editingToken, tenantId, authenticationToken);
    };

    const dropdownClasses = classnames({
        'note-controls-dropdown': true,
        open: dropDownIsOpen,
    });

    const date = moment(lastUpdated).format('L');
    const time = moment(lastUpdated).format('LT');

    return (
        <>
            <div className="note-inner">
                <div className="note-header">
                    <h1>{subject}</h1>
                    <div className="note-controls">
                        <button onClick={() => toggleDropdown(!dropDownIsOpen)} className="note-controls-cog">
                            <span className="glyphicon glyphicon-cog" />
                        </button>
                        <ul aria-hidden={!dropDownIsOpen} className={dropdownClasses}>
                            <li>
                                <button className="note-control-btn" onClick={() => edit(id)}>Edit</button>
                            </li>
                            <li>
                                <button className="note-control-btn" onClick={onDelete}>Delete</button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="note-content">
                    <p>{content}</p>
                </div>
            </div>
            <div className="note-footer">
                <span className="footer-column">{email}</span>
                <span className="footer-column created-at">{`${date} | ${time}`}</span>
            </div>
        </>
    );
};

const mapStateToProps = ({ currentUser }) => ({
    currentUser,
});

export default connect(mapStateToProps, { remove: deleteMapElement, edit: editNote })(NoteDisplay);
